import { jsx as _jsx } from "preact/jsx-runtime";
import { ConfirmationModal } from '@/components/modals/ConfirmationModal';
export function WebReopenModal({ isOpen, onClose, onConfirm, loading }) {
    return (_jsx(ConfirmationModal, { isOpen: isOpen, title: "Reopen Web", message: "Reopening will allow editing of online event details, speakers, and schedule. Changes won't sync to BigMarker until the next sign-off.", type: "warning", confirmText: "Reopen", onConfirm: onConfirm, onCancel: onClose, loading: loading }));
}
